import { defineMessages } from 'react-intl';

/* eslint-disable max-len */

export default defineMessages({
  navigateYtunnus: {
    id: 'navigation.navLink.navigateYtunnus',
    description: 'Button to search by ytunnus',
    defaultMessage: 'Go',
  },
});
